"use strict";
var updatePlot = require('./update.js');
var utils = require('./utils.js');
var _ = require('underscore');


function processData(dataObj) {
    var dates = _.map(dataObj.timestamps, function(date){return date});
    var allData = {
        dates: dates,
    };
    _.extend(allData, dataObj.data);
    return allData;
}


function plotting(dataCache, url, var_names, plotsInfo, div, update, maxPoints, err_callback) {
    //gets information and updates component
    $.ajax({
            type: 'GET',
            url: url,
            jsonp: "callback",
            dataType: "jsonp",

            success: function(dataObj) {
                if (dataObj.code != 200) {
                    console.error("Invalid data API query. Code: {0} | Message: {1}".format(
                        dataObj.code, dataObj.message));
                    if (err_callback !== undefined) {
                        // stop the update timer if specified
                        err_callback(plotsInfo);
                    }
                    return;
                }

                var graphDiv = document.getElementById(div);
                var allData = processData(dataObj['results']);
                // var existingDates = graphDiv.data[0]['x'];
                var existingDates = dataCache[0]['x'] || [];
                var dates = allData['dates'];
                dataObj = {
                    dates: dates
                };

                if (dataObj.dates.length == 0) {
                    console.warn("No data available from API");
                    return;
                }

                if (update) {
                    // first index in the new data that is actually new
                    var startIndex = 0;
                    // update only dates that aren't already included
                    // assume that we don't have any missing dates in the middle
                    while (startIndex < dates.length && dates[startIndex] <= existingDates[existingDates.length - 1]) {
                        startIndex++;
                    }

                    // subset the data if needed
                    if (startIndex >= dates.length) {
                        console.info("No new data downloaded");
                        return;
                    } else {
                        for (var i = 0; i < var_names.length; i++) {
                            dataObj[var_names[i]] = allData[var_names[i]].slice(startIndex);
                        }
                        dates = dates.slice(startIndex);
                        dataObj.dates = dates;
                    }
                } else {
                    // replace the entire data array
                    for (var i = 0; i < var_names.length; i++) {
                        dataObj[var_names[i]] = allData[var_names[i]];
                    }
                }

                // Update data with
                updatePlot.updatePlot(dataCache, graphDiv, plotsInfo, dataObj, update, maxPoints);
            }
    });
}


// 1. the minimum time period (in milliseconds) that a request must cover in order to use
// 2. MetObs Data API interval specifier
// 3. reasonable update interval for API given this data interval
const intervalLookUp = [
    // 1 day for 5 minutes
    [1000*60*60*24, '5m', '-00:10:00'],
    // 1 month for 1 hour
    [1000*60*60*24*30*1, '1h', '-02:00:00'],
    // anything else is 1 minute
];

const intervalToSeconds = {
    '1m': 60,
    '5m': 60 * 5,
    '1h': 60 * 60,
};


function varNamesForDiv(dataCache) {
    var varNames = [];
    _.each(dataCache, function(trace_data) {
        Array.prototype.push.apply(varNames, trace_data.var_names);
        if ('anc_variables' in trace_data) {
            Array.prototype.push.apply(varNames, trace_data.anc_variables);
        }
    });
    return _.uniq(varNames);
}


//poorly ordered function parameters
function requestPlotUpdate(dataCache, div, plotsInfo, startTime, endTime, interval, update, err_callback) {
    var varNames = varNamesForDiv(dataCache);
    var stream_string = '';
    var dt_in_ms;
    var time_parts;
    var maxPoints;
    var time;
    for (var i in varNames) {
        stream_string += varNames[i];
        if (i < varNames.length - 1) stream_string += ':';
    }

    if (!endTime) {
        interval = '1m';
        // hours, minutes, seconds
        time_parts = _.map(startTime.split(':'), Number);
        if (update) {
            // if we're updating then we don't need to get a ton of data every time
            startTime = "-00:05:00";
        }
        dt_in_ms = -1000 * 60 * 60 * time_parts[0] + 1000 * 60 * time_parts[1] + 1000 * time_parts[2];
        for (var i in intervalLookUp) {
            if (dt_in_ms >= intervalLookUp[i][0]) {
                interval = intervalLookUp[i][1];

                if (update) {
                    // we only want new data, the passed startTime was only
                    // used to determine the interval
                    startTime = intervalLookUp[i][2];
                }
            }
        }
        time = '&begin=' + startTime;
    } else {
        time = '&begin=' + startTime + '&end=' + endTime;
        if (interval == 'auto') {
            interval = '1m';
            dt_in_ms = (new Date(endTime)) - (new Date(startTime));
            for (var i in intervalLookUp) {
                if (dt_in_ms >= intervalLookUp[i][0])
                    interval = intervalLookUp[i][1];
            }
        }
    }


    // Maximum number of points (fallback to arbitrary 250)
    if (update) {
        maxPoints = intervalToSeconds.hasOwnProperty(interval) ? dt_in_ms / 1000 / intervalToSeconds[interval] : 250;
    } else {
        maxPoints = 0; // delete all previous data
    }
    var url = utils.buildRequestUrl('json', interval, '', '', 'column', time, stream_string);
    plotting(dataCache, url, varNames, plotsInfo, div, update, maxPoints, err_callback);
    return interval;
}


//export functions
module.exports.requestPlotUpdate = requestPlotUpdate;
